"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeatureFlagConfig = getFeatureFlagConfig;
const featureFlagsHolderObject_1 = require("./featureFlagsHolderObject");
function getFeatureFlagConfig() {
    if (featureFlagsHolderObject_1.featureFlagsHolderObject.config) {
        return featureFlagsHolderObject_1.featureFlagsHolderObject.config;
    }
    else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { platform, window } = globalThis;
        if (platform && platform.getFeatureFlags && typeof platform.getFeatureFlags === 'function') {
            return platform.getFeatureFlags();
        }
        else if (window && window.juvareFeatureFlags) {
            return window.juvareFeatureFlags;
        }
        else {
            return undefined;
        }
    }
}
